import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchContacts } from '../actions/messages';

const MessagesRoute = loadable(
  () => import(/* webpackChunkName: "messages" */ '../containers/Messages'),
  { fallback: Loading }
);

MessagesRoute.needs = async (props, { dispatch }) => {
  if (typeof SERVER !== 'undefined' && SERVER) return; //eslint-disable-line no-undef
  MessagesRoute.preload();
  return dispatch(fetchContacts());
};
export default MessagesRoute;
